export const callUnsetApi = async (siteId) => {
  try {
    const response = await fetch(
      `https://api.bharatnet.sunshineiotronics.com/api/v2/live_frame/unset/${siteId}`,
      {
        method: "GET",
      }
    );
    const data = await response.json();
    console.log("Unset API response:", data);
  } catch (error) {
    console.error("Error calling unset API:", error);
  }
};
